import OrbitApiV1 from '.'

class VersionAPI {
  static getVersion() {
    return OrbitApiV1.httpGet(`/version`)
  }
}

export default VersionAPI
